<template>

    <div class="container-fluid p-0">
        <div class="row m-0">
            <div class="col-12 p-0">
                <div class="login-card login-dark">
                    <div>
                       
                        <div class="login-main"  >

                            <h4>Fill Your Details </h4>
                            
                            <div class="form-group">
                                <label class="col-form-label">Your Name</label>
                                <input class="form-control" type="text" v-model="user.name"  @input="user.name = user.name.charAt(0).toUpperCase() + user.name.slice(1)"
                                    placeholder="Type Here..." required="">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Your Firm Name</label>
                                <input class="form-control" type="text" v-model="user.firmname"  @input="user.firmname = user.firmname.charAt(0).toUpperCase() + user.firmname.slice(1)"
                                    placeholder="Type Here..." required="">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Your Address</label>
                                <input class="form-control" type="text" v-model="user.address" @input="user.address = user.address.charAt(0).toUpperCase() + user.address.slice(1)"
                                    placeholder="Type Here..." required="">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Your Designation</label>
                                <input class="form-control" type="text" v-model="user.designation" @input="user.designation = user.designation.charAt(0).toUpperCase() + user.designation.slice(1)"
                                    placeholder="Type Here..." required="">
                            </div>

                            
                            <div class="form-group">
                                <label class="col-form-label" >Adhaar Card   </label> 
                                <input class="form-control" type="file"  @change="handleFileUpload"  ref="fileInput"   
                                    required=""  style="display: none;"><br>
                                    <img :src=" imageUrls ?imageUrls: this.$hostname+'/writable/uploads/aadhar_card/user.png'"  @click="triggerFileInput" alt="Uploaded Image" style="height: 80px; width: 80px;" />
                             
                            </div>
                       
                               

                                <!-- <div>
                                <img :src=" imageUrls || this.$hostname+'assets/file.png"  @click="triggerFileInput" alt="Uploaded Image" style="height: 80px; width: 80px;" />
                                </div> -->



                            <div class="text-end mt-3">
                                <button class="btn btn-primary btn-block w-100" @click="saveData">Submit</button>
                            </div>

                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>





</template>
<style scoped>
.page-body {
    margin-left: 0 !important;
    margin-top: 0px;
}

.user-profile .hovercard .cardheader {
    height: 100px;
    background: linear-gradient(45deg, #0437c8, #007611);
}

@media only screen and (max-width: 575.98px) {
    .tabs-scoial li:nth-child(3) {
        position: sticky;
    }
}
</style>

<script>
// import axios from 'axios';
import axios from "@/plugins/axios";

export default {
    name: 'VisitorProfile',
    components: {

    },
    mounted() {
         if (this.$route.query.q) {
                this.getBasicsWithToken(this.$route.query.q);
              } else if (localStorage['token']) {
                this.getBasics(localStorage['token'], 1);
              } else {
                  window.location.assign(window.location.origin + "");
              }
    },
    data() {
        return {
            user:{
            name: '',
            firmname: '',
            address: '',
            designation:'',
            file:''
            },
            imageUrls: null,
            
            isName:false,
            isFirmName:false,
            isAddress:false,
            isDesignation:false,
            isAdhar:false,
        }
    },
    methods: {  
      getBasics(token, isLocalToke = 0) {
        var self = this;
        axios.post('getVisitorProfile').then(function (response) {
            if(response.data.expired){
                
                localStorage.removeItem('token');
                localStorage.removeItem('_emp_token');
                 window.location.assign(window.location.origin + "/register");
                
            }
                    
            
            
          if (response.data.is == 1) {
            localStorage.removeItem('_emp_token');
            self.visitor = response.data.user;

            if (self.visitor.name == '' || self.visitor.name == null){
              self.$router.push({ name: "visitorprofile" });
            }
            else if (self.visitor.photo == '' || self.visitor.photo == null){
              self.$router.push({ name: "capture" });
            }

            self.visits = response.data.visits;
            self.past_visits = response.data.past_visits;
            window.scrollTo(0, 0);
          } else if (response.data.is == 0) {
            localStorage.removeItem('token');
            self.$router.push({ name: "register" });
          }

            if(!self.isLiveStarted){
                    self.isLiveStarted=true;
                   self.intervalId= setInterval(self.refreshPage, 10000);
                }

        });
      },

     getBasicsWithToken(token) {
        var self = this;
        axios.post('getBasicsWithToken',{token:token}).then(function (response) {
            if(response.data.expired){
                
                localStorage.removeItem('token');
                localStorage.removeItem('_emp_token');
                
                
                
            }
                    
            
            
          if (response.data.is == 1 && response.data.token) {
              
              //if verified set server token to user
                    localStorage.setItem('token',response.data.token);
                    localStorage.removeItem('_emp_token');
                    self.user = response.data.user;
    
                     
                    window.scrollTo(0, 0);
              } else if (response.data.is == 0) {
                localStorage.removeItem('token');
                self.$router.push({ name: "register" });
              }



        });
      },

    saveData() {

        var self = this;
           if (self.user.name == '')
           {
              self.$swal("Please Enter Name");
           }
           else if (self.user.firmname== '')
           {
               self.$swal("Please Enter Firm Name");
           }  
          else if (self.user.address == '')
          { 
             self.$swal("Please Enter Address");
          }

           else if (self.user.designation == '')
            {
             self.$swal("Please Enter Designation");
            }
            else if (self.user.file == '')
            {
             self.$swal("Please Upload Adhaar Card");
            }
        else{
            
                const formData = new FormData();
                formData.append('name', self.user.name);
                formData.append('firmname', self.user.firmname);
                formData.append('address', self.user.address);
                formData.append('designation', self.user.designation); 
                if (self.user.file) {
                    formData.append('file', self.user.file);
                }
                
                
                
                
       
            axios.post('saveProfile',formData).then(function (response) {
                if(response.data.is==1){ 
                    
                    if(response.data.visitor.photo=='' || response.data.visitor.photo==null){
                        self.$router.push({ name: "capture" });  
                    }
                    else{
                    
                        self.$swal({
                                title: "Successfull",
                                text: "Please Select Option From Bellow",
                                type: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonText: "Profile",
                                confirmButtonText: "Create Gatepass"
                            }).then((result) => { // <--
                                if (result.value) { // <-- if confirmed
                                    self.$router.push({ name: "visitorcreategatepass" });  
                                }else
                                    self.$router.push({ name: "visitorpage" });  
                            });
                        }
                        //self.$router.push({ name: "visitorpage" });  
                }else
                self.$swal("Please Try Again");

                window.scrollTo(0, 0);
            });
        }
  
    },
    handleFileUpload(event) {
    const file = event.target.files[0];
    this.user.file = file;

    if (file) {
      this.imageUrls = URL.createObjectURL(file);
    }
  },

  triggerFileInput() {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click();
      } else {
        console.warn("File input ref not found!");
      }
    },
    visitorprofile(){ 
            this.$router.push({ name: "capture" });   
        },

       

}
}
</script>
